export const dictionaryRoute = [{
  path: 'dictionary',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'DictionaryMain',
      component: () => import('../../../components/Admin/Dictionary'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: ':type',
      component: () => import('../../../components/router-view'),
      children: [
        {
          path: '',
          name: 'DictionariesList',
          component: () => import('../../../components/Admin/Dictionary/dictionary'),
          meta: {
            access: ['admin']
          }
        },
        {
          path: 'edit/:id',
          name: 'DictionaryEdit',
          component: () => import('../../../components/Admin/Dictionary/edit'),
          meta: {
            access: ['admin']
          }
        },
        {
          path: 'create',
          name: 'DictionaryCreate',
          component: () => import('../../../components/Admin/Dictionary/create'),
          meta: {
            access: ['admin']
          }
        }
      ]
    }
  ]
}]



// WEBPACK FOOTER //
// /src/router/admin/module/dictionary.js